import {fobBettingSubTypesFor} from "../fob.betting/fob-catalog";
import {isSelectionRenderable} from "../selection-ready";
import React from "react";
import {isMobile} from "../../../App";
import {BettingTypesMap} from "../../../features/core/definitions";

// FOB sayfasının koşu sekmeleri. Seçim bağlamı sayfadan PROP olarak geliyor (eskiden modül
// seviyesindeki `fobPageSelection` globalini okuyup forceUpdate bekliyordu).
export function BettingFobDataTabs(prop: any) {

    const selection = prop.selection;
    const selectBettingColumn = prop.selectBettingColumn;
    const selectBettingSubType = prop.selectBettingSubType;

    if (!isSelectionRenderable(selection)) {
        return (<></>)
    }

    const selectedTypeRunNos = new Set<number>(
        fobBettingSubTypesFor(selection.hippodrome, selection.bettingType).map((s: any) => Number(s.id))
    );
    const tabs: any[] = selection.hippodrome.runs.filter((run: any) => selectedTypeRunNos.has(Number(run.no)));
    const isRunPassive = (run: any) => !run.show_fob;

    const pushViewItem = (run: any) => {
        try {
            // @ts-ignore
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: 'TRY',
                    value: 0,
                    items: [{
                        item_id: `${selection.bettingType.name} / ${selection.hippodrome.location} / ${selection.bettingSubType.label} / ${selection.hippodrome._date}`,
                        item_name: selection.bettingType.name,
                        item_brand: run.type_detail,
                        item_category: selection.hippodrome.location,
                        item_category2: selection.bettingSubType.label,
                        item_category3: selection.hippodrome._date,
                        item_category4: run.time,
                        item_category5: `${run.distance}m - ${run.course}`
                    }]
                }
            })
        } catch (e) {
        }
    };

    const isPairPick = !!BettingTypesMap[Number(selection.bettingType.id)]?.isFobPairPick;

    return (<>

        <div className="betting-run-tabs badge-tabs">

            {!isMobile && <div className={"weather-info"}>
                <p className={"text-xsmall text-bolder"}>{selection.hippodrome.location}</p>
                <>
                    <span className="text-xsmall text-bolder me-2">Hava: <span
                        className="text-xsmall">{selection.hippodrome.weather?.temperature} °C | {selection.hippodrome.weather?.forecast}</span></span>
                    <span className="text-xsmall text-bolder me-2">Nem: <span
                        className="text-xsmall">%{selection.hippodrome.weather?.humidity}</span></span>
                </>
            </div>}

            {tabs.length > 0 && !isPairPick &&
                <div className={"run-betting-tabs"}>

                    {tabs.map((run: any, keyRun: number) => {
                        let columnNo = Number(run?.no);
                        const passive = isRunPassive(run);

                        return (
                            <div key={`runItem-${keyRun}`}
                                 title={passive ? 'Bu koşuda sabit ihtimalli bahis açık değil' : undefined}
                                 className={`run-betting-item ${columnNo === selection.bettingSubType.id ? 'active' : 'align-items-center justify-content-center'} ${passive ? 'passive' : ''}`}
                                 onClick={() => {
                                     if (passive) {
                                         return;
                                     }
                                     // Sekme zaten seçili türün koşusu; tür DEĞİŞTİRİLMİYOR.
                                     selectBettingSubType(Number(run.no))
                                     selectBettingColumn(columnNo)
                                     pushViewItem(run);
                                 }}>
                                {isMobile ?
                                    <div className="mobile-run">
                                    <span
                                        className="text-small text-bolder">{run.no}</span>
                                        {/* Etiket SEÇİLİ koşuda: `column` sayfa açılışında 1 kalıyor,
                                            seçili koşu 4 iken ". Koşu" 1. sekmede görünüyordu. */}
                                        {columnNo === Number(selection.bettingSubType.id) && <span
                                            className="text-xxsmall">. {`${selection.bettingType.columnLabel}`}</span>}
                                    </div>
                                    : <div className="run">
                                <span
                                    className="text-xsmall text-bolder">{run.no}</span>.
                                        <span
                                            className="text-xxsmall"> {selection.bettingType.columnLabel === 'Ayak' && isMobile ? columnNo === selection.column && `${selection.bettingType.columnLabel}` : `${selection.bettingType.columnLabel}`}</span>
                                    </div>}

                            </div>)
                    })}

                </div>}
            {
                isPairPick &&
                <div className={"run-betting-tabs"}>
                    {[1, 2].map((column: number) => (
                        <div key={`runItem-${column}`}
                             className={`run-betting-item ${column === selection.column ? 'active' : 'align-items-center justify-content-center'}`}
                             onClick={() => {
                                 const run = selection.hippodrome.runs.find((el: any) => Number(el.no) === Number(selection.bettingSubType.label));
                                 if (run) {
                                     selectBettingSubType(Number(run.no))
                                     selectBettingColumn(column);
                                     pushViewItem(run);
                                 }
                             }}>

                            <div className="mobile-run">
                                    <span
                                        className="text-small text-bolder">{column}</span>
                                <span
                                    className="text-xxsmall">. At</span>
                            </div>


                        </div>
                    ))}
                </div>
            }
        </div>
    </>)
}
